import { render } from "./bookingCofirm.vue?vue&type=template&id=1d514711&scoped=true"
import script from "./bookingCofirm.vue?vue&type=script&lang=js"
export * from "./bookingCofirm.vue?vue&type=script&lang=js"

import "./bookingCofirm.vue?vue&type=style&index=0&id=1d514711&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d514711"]])

export default __exports__